module.exports = __webpack_public_path__ + "img/V3.0698dea5.jpg";